import * as React from 'react';

import { FormGroup } from 'reactstrap';

export interface Filter {
  name: string;
  label: string;
  options: FilterOption[];
}
export interface FilterOption {
  label: string;
  value: string;
}
export interface FiltersProps {
  value: string;
  onChange: (query: string) => void;
  filters: Filter[];
}

export interface FiltersState {}

export class Filters extends React.Component<FiltersProps, FiltersState> {
  getFilter(name: string) {
    let match = this.props.value.match(new RegExp(name + ':([^ ]+)'));
    return match && match[1] ? match[1] : '';
  }

  setFilter = (filter: string, value: string) => {
    let query = this.props.value;
    query = query.replace(new RegExp(filter + ':[^ ]+'), '');
    if (value) {
      query += ' ' + filter + ':' + value;
    }
    query = query.replace(/[ ]+/g, ' ').trim();
    this.props.onChange(query);
  };

  handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let filter = e.target.id.replace('filter-', '');
    this.setFilter(filter, e.target.value);
  };

  render() {
    return (
      <div className="row">
        {this.props.filters.map((f, i) => (
          <div key={`filters--${f.name}${i}`} className="col">
            <FormGroup>
              <label htmlFor={'filter-' + f.name}>{f.label}</label>
              <select
                id={'filter-' + f.name}
                className="form-control"
                onChange={this.handleChange}
                value={this.getFilter(f.name)}
              >
                {f.options.map((opt, j) => (
                  <option key={'filter-' + f.name + j} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </FormGroup>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Filters.tsx